import styled from 'styled-components';

export const MinMaxInputContainer = styled.div`
    display: flex;
    gap: 2rem;
`;
